<template>
  <div class="mk-autoweb-header2">
    <div class="header_inner">
      <div class="header_logo fl">
        <a>
          <img :src="childItem.propsValue.data.customField1" width="100%" />
        </a>
      </div>
      <ul>
        <li
          v-for="(item, index) in childItem.propsValue.data.customField3"
          :key="index"
        >{{item.customField5}}</li>
      </ul>
      <div class="search">
        <input type="text" placeholder="请输入" />
        <img src="https://mks.yybip.com/group1/M00/09/2B/CgoRC2Oo_32ACnQxAAAec_6zgB0177.png" alt />
      </div>
      <div class="header_r fr">
        <div class="header-nav fl"></div>
        <div class="header-box">
          <img src="https://mks.yybip.com/group1/M00/01/7C/CgoRDGOpAFOADM17AAEvJyGQtSY478.gif" />
          <a class="login" style="margin-right: 0px">{{childItem.propsValue.data.customField2}}</a>
          <img src="https://mks.yybip.com/group1/M00/09/2B/CgoRC2OpAGeAJjXAAAAtgSSxZCI831.gif" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkHeader2Web",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 84,
          height: 62
        },
        {
          code: "customField9",
          label: "链接",
          type: "text"
        },
        {
          code: "customField2",
          label: "电话",
          type: "text"
        },
        {
          code: "customField3",
          label: "菜单",
          labelField: "customField5",
          type: "tree",
          children: [
            {
              code: "customField4",
              label: "logo",
              type: "image",
              width: 80,
              height: 80
            },
            {
              code: "customField5",
              label: "标题",
              type: "text"
            },
            {
              code: "customField6",
              label: "描述",
              type: "text"
            },
            {
              code: "customField7",
              label: "类型",
              type: "radio",
              defaultValue: '_self',
              data: [
                {
                  label: "当前页面打开",
                  value: "_self"
                },
                {
                  label: "新页签打开",
                  value: "_blank"
                }
              ]
            },
            {
              code: "customField8",
              label: "地址",
              type: "text"
            }
          ]
        }
      ],
      data: {
        customField1:
          "https://mks.yybip.com/group1/M00/01/3B/CgoRDGMYZmGAHJsqAAAMhr5ZOHY294.png",
        customField2: "4006-600-577",
        customField3: [],
        customField9: ""
      }
    };
  }
};
</script>


<style lang="scss">
.mk-autoweb-header2 {
  width: 100%;
  height: 50px;
  background: #fff;
  box-shadow: "0px 0px 11px 0px rgb(0 0 0 / 10%)";
  background: "#FFFFFF";
  .header_logo a {
    background-size: 100% 100%;
    width: 50px;
    height: 100%;
    display: block;
    position: relative;
    img {
      display: block;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  .header_inner {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    > ul {
      display: flex;
      line-height: 70px;
      width: 530px;
      // justify-content: space-around;
      li {
        margin: 0 30px;
        font-size: 16px;
      }
    }
    .search {
      position: relative;
      width: 120px;
      input {
        border: 1px solid #b3b3b3;
        width: 100px;
        height: 34px;
        line-height: 70px;
        margin-top: 18px;
        border-radius: 4px;
        margin-left: 10px;
        margin-right: 20px;
        padding-left: 10px;
      }
      img {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 25px;
        left: 85px;
      }
    }

    .header-box {
      width: 160px;
      .login {
        color: #e60012;
        line-height: 70px;
        font-size: 14px;
        margin-right: 5px;
      }
      img:nth-child(1) {
        display: block;
        float: left;
        margin-top: 20px;
        margin-right: 5px;
        height: 30px;
      }
      img:nth-child(3) {
        height: 25px;
        float: right;
        margin-top: 5px;
      }
    }
  }
}
</style>
